import * as React from 'react'
import Content from '../../../../pages/shared/content'

// FunnelOrder
interface PassProps {
  passDetails: PassDetails
  totalPeople: number
}

export interface PassDetails {
  youngPass: number
  adultPass: number
}

export interface TotmOrder {
  passDetails: PassDetails
  numberOfPasses: number
}

export const initialPassDetails: PassDetails = {
  youngPass: 0,
  adultPass: 0,
}

export const initialTotmOrder: TotmOrder = {
  passDetails: initialPassDetails,
  numberOfPasses: 0,
}

export function getDescriptionFromPassDetails(value: PassProps) {
  return (
    <Content
      addNode
      contentKey="interrail-description"
      vars={{
        youngPass: value.passDetails.youngPass.toString(),
        adultPass: value.passDetails.adultPass.toString(),
      }}
    >
      {`${value.passDetails.youngPass}x Jongerenpas, ${value.passDetails.adultPass}x Volwassendepas`}
    </Content>
  )
}

// Traveler
export interface TotmTraveler {
  PassportNumber: string
}

export const initialTotmTraveler: TotmTraveler = {
  PassportNumber: '',
}

// Payment
export interface TotmPayment {
  InterrailTandC: boolean
}

export const intitalTotmPayment: TotmPayment = {
  InterrailTandC: false,
}
